import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white text-gray-800 font-sans">
            <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-amber-700 hover:text-amber-800 font-semibold mb-8 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <h1 className="text-4xl font-bold text-gray-900 mb-8 border-b pb-4 border-amber-100">Privacy Policy</h1>

                <div className="space-y-6 text-lg leading-relaxed">
                    <p>
                        At Nayan's Kitchen & Delights, we take your privacy seriously. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our website and services.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Information We Collect</h2>
                    <p>
                        We collect personal information that you provide to us when you register on the website, express an interest in obtaining information about us or our products and services, or when you participate in activities on the website. The personal information we collect depends on the context of your interactions with us and the website, the choices you make, and the products and features you use. This includes details like your name, phone number, email address, and delivery address.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. How We Use Your Information</h2>
                    <p>
                        We use the information we collect or receive to facilitate order creation, delivery, and to process payments securely. We also use it to respond to user inquiries and offer support to users. We may use your information for administrative purposes, to request feedback, or to contact you about your use of our services.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Data Security</h2>
                    <p>
                        We implement appropriate technical and organizational security measures to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Sharing Your Information</h2>
                    <p>
                        We only share information with your consent, to comply with laws, to provide you with services (such as sharing your address with delivery partners and processing payments through secure payment gateways), or to protect our rights.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Contact Us</h2>
                    <p>
                        If you have questions or comments about this policy, you may email us at hellonayanskitchen@gmail.com.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
